module.exports = __webpack_public_path__ + "img/01.e16bb8a3.png";